import { useEffect, useState } from 'react';
import { Alert, Button, Group, Text } from '@mantine/core';
import { IconEye } from '@tabler/icons-react';
import { useAuthStore } from '../../stores/auth';
import { api } from '../../lib/api';

/**
 * Leiste der Ansicht als Nutzer (nur Admin, nur lesen, 30 Min.). Wer den ServiceHub in fremder
 * Sicht offen hat, darf das keinen Moment vergessen — sonst hält man gesperrte Knöpfe für einen
 * Fehler. Läuft die Zeit ab, geht es von selbst zurück zur eigenen Sicht.
 */
export function ViewAsBanner() {
  const user = useAuthStore((s) => s.user);
  const viewAs = user?.viewAs;
  const [now, setNow] = useState(() => Date.now());
  const [ending, setEnding] = useState(false);

  useEffect(() => {
    if (!viewAs) return;
    const t = setInterval(() => setNow(Date.now()), 15_000);
    return () => clearInterval(t);
  }, [viewAs]);

  const msLeft = viewAs ? new Date(viewAs.expiresAt).getTime() - now : 0;

  useEffect(() => {
    // Abgelaufen: Server liefert ohnehin wieder die eigene Sicht — Seite neu laden, damit nichts
    // aus der fremden Sicht im Speicher stehen bleibt.
    if (viewAs && msLeft <= 0) window.location.assign('/admin/users');
  }, [viewAs, msLeft]);

  if (!viewAs) return null;

  const end = async () => {
    setEnding(true);
    try {
      await api.endViewAs();
    } finally {
      window.location.assign('/admin/users');
    }
  };

  const minutes = Math.max(0, Math.ceil(msLeft / 60_000));
  return (
    <Alert color="orange" variant="filled" radius="md" mb="md" icon={<IconEye size={20} />}
      title={`Ansicht als ${user?.displayName ?? 'Nutzer'}`}>
      <Group justify="space-between" align="center" gap="sm" wrap="wrap">
        <Text size="sm" style={{ flex: 1, minWidth: 240 }}>
          So sieht {user?.displayName ?? 'der Nutzer'} den ServiceHub. Nur ansehen — Speichern, Senden und
          Ändern sind gesperrt. Endet in {minutes} Min. von selbst.
        </Text>
        <Button color="dark" variant="white" size="xs" loading={ending} onClick={() => void end()}>
          Zurück zu meiner Sicht
        </Button>
      </Group>
    </Alert>
  );
}
